<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCard class="p-4">
            <CCardHeader>
              <h1>ログイン</h1>
            </CCardHeader>
            <CCardBody>
              <CForm v-if="!isAdLogin">
                <CInput
                  v-model="inputItems.email"
                  placeholder="メールアドレス"
                  autocomplete="email"
                >
                  <template #prepend-content
                    ><CIcon name="cil-user"
                  /></template>
                </CInput>
                <CInput
                  id="Password"
                  v-model="inputItems.password"
                  placeholder="パスワード"
                  type="Password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content
                    ><CIcon name="cil-lock-locked"
                  /></template>
                </CInput>
                <template>
                  <CRow form class="form-group">
                    <CCol sm="3">
                      <CInputCheckbox
                        label="パスワード表示"
                        @change="changed"
                      />
                    </CCol>
                  </CRow>
                </template>
                <CAlert :show.sync="alertCountDown" :color="alertClr" fade>
                  {{ Msg }}
                </CAlert>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" @click="loginClick" class="px-4"
                      >ログイン</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
              <CRow v-if="isAdLogin">
                <a href="/auth/login">Please Login here</a>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
const COMMON_PASSWORD = 'dcsdcsdcs';
export default {
  name: "Login",
  data() {
    return {
      inputItems: {
        email: "",
        password: "",
      },
      Msg: "",
      alert: "",
      alertClr: "",
      alertCountDown: 0,
      isAdLogin: process.env.VUE_APP_IS_ADLOGIN === "true",
    };
  },
  async mounted() {
    if (this.isAdLogin) {
      // 初期データ取得
      let loginId = null;
      let isLogin = false;
      await this.$axios.get("/auth/isLogin").then((res) => {
        isLogin = res.data.isLogin;
      });
      if (!isLogin) return;
      await this.$axios
        .get("/api/v1/AdLogin")
        .then((res) => {
          const loginUser = res.data.login;
          loginId = loginUser.user_id;
          if (loginUser) {
            //ユーザ情報をstoreに送信
            this.$store.dispatch("auth", {
              islogin: true,
              loginUser: loginUser,
            });
          } else {
            console.error("AD-User does not exist in the system.");
            document.location.href = "/auth/logout";
          }
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
        });
      if (loginId) {
        // CSRFトークン取得・設定
        await this.loginCSRF();
        // 最終ログイン日時更新処理
        await this.updateloginUser(loginId);
        await this.$router.push({ name: "トップページ" });
      }
    } else {
      if (this.$store.state.islogin) {
        this.$router.push({ name: "トップページ" });
      }
    }
  },
  methods: {
    async loginCSRF() {
      // CSRFトークン取得・設定
      await this.$axios.get("/api/v1/getcsrftoken").then(
        (res) =>
          (this.$axios.defaults.headers.common["X-CSRF-TOKEN"] =
            res.data.csrfToken),
        (err) => console.error(err)
      );
    },
    //パスワード表示クリック
    changed() {
      const inputPass = document.getElementById("Password");
      if (inputPass.type == "text") {
        inputPass.type = "password";
      } else if (inputPass.type == "password") {
        inputPass.type = "text";
      }
    },
    //ログインボタンクリック
    async loginClick() {
      const email = this.inputItems.email;
      const password = this.inputItems.password;
      if (email == "") {
        this.alertClr = "danger";
        this.Msg = "メールアドレスを入力してください";
        this.countDownChanged(5);
        return;
      } else if (password == "") {
        this.alertClr = "danger";
        this.Msg = "パスワードを入力してください";
        this.countDownChanged(5);
        return;
      }
      //ログイン認証
      var isAuth = false;
      const loginUser = await this.loginUser(email);
      if (loginUser && password === COMMON_PASSWORD) {
        isAuth = true;
      }
      //存在チェック
      if (isAuth) {
        this.alertClr = "success";
        this.Msg = "ログインに成功しました";
        //ユーザ情報をstoreに送信
        this.$store.dispatch("auth", {
          islogin: true,
          loginUser: loginUser,
        });
        // 最終ログイン日時更新処理
        await this.updateloginUser(loginUser.user_id);
      }
      if (this.alertClr === "success") {
        this.$router.push({ name: "トップページ" });
      } else {
        this.alertClr = "danger";
        this.Msg = "社員番号またはパスワードが間違っています";
        this.countDownChanged(5);
      }
    },
    //バックエンド問い合わせ
    async loginUser(email) {
      let ret = null;
      await this.$axios
        .get("/api/v1/loginUser/" + email)
        .then((res) => {
          ret = res.data.login;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
        });
      return ret;
    },
    //メッセージ表示カウント
    countDownChanged(sec) {
      this.alertCountDown = sec;
    },
    //ログイン日時更新
    async updateloginUser(id) {
      await this.$axios.put("/api/v1/updateLoginUser/" + id)
      .catch((e) => {
        console.error(e.response.data.message);
      });
    },
  },
};
</script>